import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IoRefreshOutline } from "react-icons/io5";
import * as S from "./IASistemasStyle";
import DashboardTab from "./DashboardTab";
import ChatsTab from "./ChatsTab";
import TicketsTab from "./TicketsTab";
import RelatoriosTab from "./RelatoriosTab";
import { iaService } from "../../Services/iaService";

// Relatórios IA: oculto por enquanto (código pronto em RelatoriosTab.js).
// Para reativar, mude para true.
const SHOW_RELATORIOS = false;

const MENU = [
  { key: "dashboard", label: "Visão Geral" },
  { key: "instagram", label: "Leads Instagram" },
  { key: "website", label: "Leads Website" },
  { key: "plataforma", label: "Clientes Plataforma" },
  { key: "tickets", label: "Tickets" },
  ...(SHOW_RELATORIOS ? [{ key: "relatorios", label: "Relatórios IA" }] : []),
];

const horaAgora = () =>
  new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

export default function IASistemas() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [online, setOnline] = useState(null);
  const [instagramEnabled, setInstagramEnabled] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [lastUpdate, setLastUpdate] = useState(horaAgora());

  // Aba ativa vive na URL (?tab=...) — sobrevive ao refresh
  const validKeys = MENU.map((m) => m.key);
  const tabParam = searchParams.get("tab");
  const tab = validKeys.includes(tabParam) ? tabParam : "dashboard";

  const checkHealth = () => {
    iaService
      .getDashboardStats()
      .then((stats) => {
        setOnline(true);
        setInstagramEnabled(stats?.instagram_enabled !== false);
      })
      .catch(() => setOnline(false));
  };

  useEffect(() => {
    checkHealth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTab = (key) => {
    // Trocar de aba limpa chat/filtros da aba anterior e renova os dados
    setSearchParams({ tab: key }, { replace: false });
    setLastUpdate(horaAgora());
  };

  /** Recarrega todos os dados da aba aberta (remonta o conteúdo). */
  const handleRefresh = () => {
    setRefreshKey((k) => k + 1);
    setLastUpdate(horaAgora());
    checkHealth();
  };

  // Canais desligados no backend somem do menu automaticamente
  const menu = MENU.filter((item) => item.key !== "instagram" || instagramEnabled);

  return (
    <S.Page>
      <S.Navbar>
        <S.NavbarTop>
          <S.Brand>
            <S.BrandMark>IA</S.BrandMark>
            <S.BrandText>
              <h1>IA Sistemas</h1>
              <small>Golden Brasil · Atendimento Inteligente</small>
            </S.BrandText>
          </S.Brand>
          <S.NavbarRight>
            <S.UpdateChip
              onClick={handleRefresh}
              title="Clique para recarregar os dados desta tela"
            >
              <span className="icone">
                <IoRefreshOutline />
              </span>
              Atualizado às <time>{lastUpdate}</time>
            </S.UpdateChip>
            {online !== null && (
              <S.StatusPill $offline={!online}>
                {online ? "Ana operando normalmente" : "Serviço indisponível"}
              </S.StatusPill>
            )}
          </S.NavbarRight>
        </S.NavbarTop>

        <S.NavMenu>
          {menu.map((item) => (
            <S.NavItem
              key={item.key}
              $active={tab === item.key}
              onClick={() => handleTab(item.key)}
            >
              {item.label}
            </S.NavItem>
          ))}
        </S.NavMenu>
      </S.Navbar>

      <S.Content key={`${tab}-${refreshKey}`}>
        {tab === "dashboard" && <DashboardTab />}
        {tab === "instagram" && (
          <ChatsTab platform="instagram" titulo="Leads Instagram" />
        )}
        {tab === "website" && <ChatsTab platform="website" titulo="Leads Website" />}
        {tab === "plataforma" && (
          <ChatsTab platform="plataforma" titulo="Clientes Plataforma" />
        )}
        {tab === "tickets" && <TicketsTab />}
        {tab === "relatorios" && <RelatoriosTab />}
      </S.Content>
    </S.Page>
  );
}
